export default function ValidationError({ value }) {
    return <div className="text-red-600">{value ? value[0] : ""}</div>;
}
